module.exports = __webpack_public_path__ + "media/images/growth_mindset/background-indicator-d417b23046efaa2eee039338b7ff8711.png";